import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { Router, RouterEvent, NavigationEnd, NavigationStart, NavigationCancel, NavigationError } from '@angular/router';
import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-mp-font',
  templateUrl: './mp-font.component.html',
  styleUrls: ['./mp-font.component.css', '../../../assets/css/_MP_Front.css']
})
export class MPFontComponent implements OnInit {
  localStorage: any;
  sURL: any;

  constructor(private http: HttpClient, private System: TSFuntionService, private router: Router, private swal: SWAlertService, private Authen: AuthService) {
    router.events.subscribe((event: RouterEvent) => {
      this.GetMainHead(event.url);
    })
  }


  public _MenuR = [];
  public showOverlay = true;
  sFullName: string = "";
  sRole: string = "";
  ImgUser: string = "";
  YearOfDate: string = "";
  IsSVM = false;
  //sURL: string = "";
  ArrMain: [];
  ngOnInit() {
    this.System.ClearTimeInterval();
    this.System.CreateTimeInterval();
    this.GetMenu();
    this.YearOfDate = new Date().getFullYear() + "";
    let ua = this.System.GetUserStorage();
    if (ua != null) {
      this.sFullName = ua.sFullName;
      this.sRole = ua.sRoleName;
      this.ImgUser = "assets/images/EMP_ICO.png";
      this.IsSVM = (ua.nRole == 6 || ua.nRole == 1);
    }
    else {
      this.System.SessionExpire();
      //this.System.UnBlockUI();
    }

  }

  checkClickMennu () {
   const screenSize = window.innerWidth;
   const divBTNSlide = document.getElementById('divMenuLeft');
   if (screenSize < 992) {
     divBTNSlide.style.display = 'none';
   }

  }

  GetMainHead(sURL) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    var data = {
      sHead: sURL
    }
    let ITEM = JSON.stringify(data)
    this.http.post<any>(this.System.SiteName + 'api/_System/GetMainHead', ITEM, { headers, responseType: 'json' }).subscribe(res => {
      if (res) {
        this.ArrMain = res;
      }
    });
  }

  onClick() {
    this.router.navigate(["/home"]);
  }

  GetMenu() {
    const httpOptions = {
      //params: new HttpParams().set("foo", "moo").set("limit", "25")
      params: new HttpParams()
    };
    this.http.get<any>(this.System.SiteName + "api/_Menu/GetMenuHome").subscribe(res => {
      this._MenuR = res;
    });
  }

  MenuDisplay = false;
  HideMenu() {
    this.MenuDisplay = !this.MenuDisplay;
  }

  LogOut() {
    let This = this;
    this.System.ClearTimeInterval();
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Logout, function () {
      This.router.navigate(["/login"]);
    }, function () {
      Swal.close();
    });
  }

  SlideMenu() {
    const divBTNSlide = document.getElementById('divBTNSlide');
    const divMenuLeft = document.getElementById('divMenuLeft');
    const screenSize = window.innerWidth;
    const bodyIS = document.getElementById('body-Is');
    if (divMenuLeft.style.display === 'none') {
      divMenuLeft.style.display = 'block';

      divBTNSlide.style.display = (screenSize > 992) ? 'none' : 'block';
    } else {
      divMenuLeft.style.display = 'none';

      divBTNSlide.style.display = (screenSize < 992) ? 'none' : 'block';
    }

    const CTRL_adjust_tb_Resize = document.getElementById('adjust_tb_Resize');
    if (CTRL_adjust_tb_Resize) {
      CTRL_adjust_tb_Resize.style.width = '1000px';
      CTRL_adjust_tb_Resize.style.width = (document.getElementById('divResize').clientWidth) + 'px';
    }
    const CTRL_divFlowChart = document.getElementById('divFlowChart');
    if (CTRL_divFlowChart) {
      CTRL_divFlowChart.style.width = '1000px';
      CTRL_divFlowChart.style.width = (document.getElementById('divFlowResize').clientWidth) + 'px';
    }
  }
}


interface _TM_Menu {
  nMenuId: number;
  nMenuHeadId: number;
  sMenuName: string;
  sIcon: string;
  sClass: string;
  sStyle: string;
  nLevel: string;
  sType: string;
  sUrl: string;
  isOpenFile: boolean;
  isActive: boolean;
  isShow: boolean;
  nOrder: number;
}
